export default "__VITE_ASSET__1b4f3432__"